import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Typography, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../../utility/helper';

const useStyles = makeStyles((theme) => ({
    tableHead: {
        backgroundColor: '#c0cbd6'
    },
    paper: {
        height: '450px'
    },
    tableContainer: {
        //padding: theme.spacing(2),
        width: '100%',
        maxHeight: 422,
    }

}));


const ShootingDrills = (props) => {

    const classes = useStyles();
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('');
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        let data = [];
        if (props.data) {
            props.data.forEach(i => {
                if (i.region)
                    data.push({ region: i.region, result: `${i.noOfMade} / ${i.maxCount}`, percentage: i.percentage });
            });
            setReportData(data);
        }

    }, [props.data])

    const headers = [
        { label: 'Drill', key: 'region' },
        { label: 'Result', key: 'result' },
        { label: 'Percentage', key: 'percentage' },
    ];

    const getTableColumns = () => {
        return ['Drill', 'Result', 'Percentage'];
    };

    const handleSort = (orderByColumn, data, firstLoad = false) => {
        let newOrder = firstLoad ? order : ((orderBy === '' || orderBy === orderByColumn) && order === 'asc') ? 'desc' : 'asc';
        let res = headers.find(i => i.label === orderByColumn);
        if (res) {
            let orderByCol = res.key;
            if (orderByCol === 'submittedOn' || orderByCol === 'gameDate') {
                let newRows = [...data];
                newRows.sort(function (a, b) {
                    return new Date(a[orderByCol]) - new Date(b[orderByCol]);
                });
                if (newOrder == 'desc') {
                    newRows = newRows.reverse();
                }
                setOrder(newOrder);
                setOrderBy(orderByColumn);
                setReportData(newRows);
            } else {
                let result = Helper.stableSort([...data], Helper.getComparator(newOrder, orderByCol));
                setOrder(newOrder);
                setOrderBy(orderByColumn);
                setReportData(result);
            }
        }
    };
    return (
        <div>
            <div style={{ padding: 10 }}>
                <Grid container alignItems='center'>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant='subtitle1' color='primary' style={{ fontWeight: 'bold' }} > Shooting Drills</Typography>
                        </div>
                    </Grid>

                </Grid>
            </div>
            <div style={{ margin: 12, marginTop: 6 }}>
                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table aria-label="simple table" className={classes.table}>
                        <TableHead className={classes.tableHead}>
                            <TableRow>
                                {
                                    getTableColumns().map((column, index) => {
                                        return (
                                            <TableCell key={index} size="small" align={index === 0 ? 'left' : 'center'}>
                                                <TableSortLabel
                                                    active={orderBy === column}
                                                    classes={{ root: classes.tablesortlabelroot, active: classes.tablesortactivelabel, icon: classes.tablesorticon }}
                                                    direction={orderBy === column ? order : 'asc'}
                                                    onClick={() => handleSort(column, reportData)}
                                                >{column}</TableSortLabel>
                                            </TableCell>
                                        )
                                    })
                                }

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData && reportData.length > 0 ?
                                reportData.map((row) => (
                                    <TableRow
                                        key={row.region}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.region}
                                        </TableCell>
                                        <TableCell align="center" style={{ paddingRight: 30 }}>{row.result}</TableCell>
                                        <TableCell align="center" style={{ paddingRight: 30 }}>{row.percentage}</TableCell>
                                    </TableRow>
                                ))
                                :
                                !props.isLoading ?
                                    <TableRow>
                                        <TableCell colSpan={3} scope="row" align="center">No data found</TableCell>
                                    </TableRow>
                                    : null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    )
}

export default ShootingDrills;